import React from "react";
import banner from "../../assets/images/dr_hemanth_banner.png";
import { ArrowRight } from "lucide-react";
import layer from "../../assets/icons/main_banner_layer-01-01.svg";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import heartpulse from "../../assets/animations/heartbeat.json";
import smily from "../../assets/animations/team.json"
const HomeBanner = () => {
  return (
    <div className="w-full min-h-screen md:pt-40 pt-28 flex items-center   relative justify-start bg-gradient-to-br from-white from-[20%] to-[#a3b8e8]">
      <div className="left-0 absolute bottom-0 w-1/3">
        <img src={layer} alt="" />
      </div>
      <div className="2xl:right-60 xl:right-32 lg:right-0 lg:block hidden absolute bottom-0 xl:w-[35%] w-1/2">
        <img src={banner} loading="lazy" alt="" className=" w-full" />
      </div>
      <div
        data-aos="fade-up"
        className="xl:w-[1200px] w-11/12 mx-auto relative "
      >
        <p className="text-lg text-[#B87333] pt-14 uppercase leading-4 font-medium tracking-widest">
          For Better Healthcare
        </p>
        <h1 className="xl:text-[58px] md:text-5xl text-3xl py-5 text-matcha leading-[1.1em] font-bold">
          Health with Hemanth <br /> exists to simplify wellness
        </h1>
        <p className="xl:text-lg text-base leading-7 text-matcha mb-11">
          Cutting through the noise of fad diets and overcomplicated <br />
          routines to give you one clear path: eat clean, move daily, live light
        </p>
        <Link
          to="/specialities"
          className="bg-matcha py-3 w-48 px-3 text-white text-base font-semibold border border-matcha  flex flex-row items-center justify-center gap-4 rounded-md hover:bg-transparent hover:text-matcha duration-200 transition"
        >
          My Specialities <ArrowRight strokeWidth={1} />
        </Link>
        <div className="flex md:flex-row md:gap-10 gap-5 flex-col md:mt-10 mt-10">
          <div className="flex flex-row justify-start items-center gap-2">
            <div className="w-[70px] h-[70px]">
              <Lottie animationData={heartpulse} loop={true} />
            </div>
            <div>
              <p className="text-[#1d9e75] text-2xl font-bold">5K+</p>
              <p className="text-matcha text-base font-medium">
                Recovered Patients
              </p>
            </div>
          </div>
         <div className="flex flex-row justify-start items-center gap-2">
            <div className="w-[70px] h-[70px]">
              <Lottie animationData={smily} loop={true} />
            </div>
            <div>
              <p
                className="text-[#1d9e75]
               text-2xl font-bold"
              >
                98%
              </p>
              <p className="text-matcha text-base font-medium">
                Satisfaction Rate
              </p>
            </div>
          </div>
        </div>
        <div className="mx-auto lg:hidden block">
          <img src={banner} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
